
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class Merchant extends Vue {
  public formTitle = 'مدیریت شرکت های همکار';
  public desserts = [];
  public dialog = false;
  public depositDialog = false;
  public withdrawDialog = false;
  public formDeleteTitle = 'آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟';
  public dialogDelete = false;
  public editedIndex = -1;
  public headers = [
    { text: 'نام', value: 'name' },
    { text: 'اعتبار', value: 'credit' },
    { text: 'تعداد سیمکارت', value: 'totalSimCount' },
    { text: 'حد ارسال پیامک هشدار شارژ', value: 'alarmBalance' },
    { text: 'قطع سرویس', value: 'suspendBalance' },
    { text: 'وضعیت', value: 'isDisabled' },
    { text: 'عملیات', value: 'action', sortable: false }
  ];
  public editedItem = {
    id: 0,
    name: '',
    alarmBalance: 0,
    suspendBalance: 0
  };
  public defaultItem = {
    id: 0,
    name: '',
    alarmBalance: 0,
    suspendBalance: 0
  };
  public transferItem = {
    id: 0,
    companyId: 0,
    amount: 0,
    description: ''
  };
  public defaultTransferItem = {
    id: 0,
    companyId: 0,
    amount: 0,
    description: ''
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'شرکتها',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getCompanies().then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  editItem(item: any) {
    this.editedIndex = this.desserts.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  async save() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    if (this.editedIndex > -1) {
      await Api.editCompany(this.editedItem).then((response: any) => {
        this.close();
        this.$showNotification('success', 'Record Updated');
        this.$hideLoading();
      });
    } else {
      await Api.createCompany(this.editedItem).then((response: any) => {
        this.close();
        this.$showNotification('success', 'Record Created');
        this.$hideLoading();
      });
    }
  }

  async enableItem(id: number) {
    await Api.enableCompany(id).then((response: any) => {
      this.close();
      this.$showNotification('success', 'شرکت فعال شد');
      this.$hideLoading();
    });
  }

  async disableItem(id: number) {
    await Api.disableCompany(id).then((response: any) => {
      this.close();
      this.$showNotification('success', 'شرکت غیرفعال شد');
      this.$hideLoading();
    });
  }

  deleteItem(id: number) {
    this.editedIndex = id;
    this.dialogDelete = true;
  }

  async deleteItemConfirm(id: number) {
    this.$showLoading();
    await Api.deletCompany(id).then((response: any) => {
      this.close();
      this.$hideLoading();
    });
  }

  depositItem(id: number) {
    this.transferItem.companyId = id;
    this.depositDialog = true;
  }

  async depositWallet() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createWalletDeposit(this.transferItem).then((response: any) => {
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد.');
      this.close();
      this.$hideLoading();
    });
  }

  withdrawItem(id: number) {
    this.transferItem.companyId = id;
    this.withdrawDialog = true;
  }

  async withdrawWallet() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createWalletWithdraw(this.transferItem).then((response: any) => {
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد.');
      this.close();
      this.$hideLoading();
    });
  }

  async detail(id: string) {
    this.$router.push({ name: 'CompanyProduct', params: { id: id } });
  }

  async transaction(id: string) {
    this.$router.push({ name: 'WalletTransaction', params: { id: id } });
  }

  async access(id: string) {
    this.$router.push({ name: 'CompanyAccess', params: { id: id } });
  }

  async close() {
    this.dialog = false;
    this.dialogDelete = false;
    this.depositDialog = false;
    this.withdrawDialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.transferItem = Object.assign({}, this.defaultTransferItem);
      this.editedIndex = -1;
    });
    this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(isDisabled: string) {
    if (isDisabled === 'فعال') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
